import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowRight, Zap } from 'lucide-react';

interface MissingInfoActionsProps {
  onProvideInfo: () => void;
  onContinue: () => void;
  isLoading?: boolean;
  missingFields: string[];
}

export function MissingInfoActions({ onProvideInfo, onContinue, isLoading, missingFields }: MissingInfoActionsProps) {
  const fieldLabels = {
    fullName: 'full name',
    email: 'email address',
    phone: 'phone number',
    workExperience: 'work experience',
    education: 'education details'
  };

  const missingFieldNames = missingFields.map(field => 
    fieldLabels[field as keyof typeof fieldLabels] || field
  );

  return (
    <Card className="w-full max-w-2xl mx-auto p-4 bg-card/50 backdrop-blur-sm border-border/50">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <Badge variant="secondary" className="text-xs">
              {missingFields.length} field{missingFields.length > 1 ? 's' : ''} needed
            </Badge>
            <span className="text-sm text-muted-foreground">
              for optimal resume enhancement
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Missing: {missingFieldNames.join(', ')}
          </p>
        </div>
        
        <div className="flex gap-2 ml-4">
          <Button
            onClick={onProvideInfo}
            disabled={isLoading}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            <Zap className="w-4 h-4 mr-2" />
            Provide
          </Button>
          
          <Button
            variant="outline"
            onClick={onContinue}
            disabled={isLoading}
            className="border-input-border hover:bg-accent"
          >
            Continue
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </Card>
  );
}
